import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';

@Pipe({
  name: 'yesNo',
  pure: false
})
export class YesNoPipe implements PipeTransform {
  constructor(public translate: TranslateService) {
    keysToTranslate<boolean>([true, false]);
  }

  transform(value: boolean): string {
    if (value) {
      return this.translate.instant('true');
    }
    return this.translate.instant('false');
  }
}
